<div class="form-group" [formGroup]="group">
    <mat-checkbox  color="primary" [formControlName]="field.name" [ngClass]="{'custom-field-invalid': group.get(field.name).invalid}">{{field.label}}</mat-checkbox>

    <app-error-validation-messages [group]="group" [field]="field"></app-error-validation-messages>

</div>
